<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">{{ params.title || 'Notaire' }}</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body">
      <div class="is-padding-bottom is-border-bottom is-margin-bottom">
        <r-label
          :label="notaire.tiers_id ? 'Notaire du référentiel' : 'Rechercher un notaire au référentiel'"
          :is-required="false"
          :value="selectedInterlocuteur"></r-label>
        <tiers-selector
          :selected="selectedInterlocuteur"
          :types="['notaire']"
          placeholder="Nom, ville..."
          @select="selectInterlocuteur"
          @unlink="unlinkTiers"></tiers-selector>
        <div
          v-if="notaire.tiers_id"
          class="is-padding-top-xsmall is-size-7 has-text-grey">
          <span class="icon is-small"><i class="fal fa-info-circle"></i></span>
          Informations issues de la fiche du référentiel — modifiables depuis la fiche Tiers, répercutées partout.
        </div>
      </div>
      <form
        id="form-user"
        class="">
        <div class="columns is-multiline">
          <div class="column is-12">
            <r-label
              :label="'Nom du notaire'"
              :is-required="false"
              :value="notaire.name"></r-label>
            <v-input
              id="name"
              :disabled="!!notaire.tiers_id"
              name="name"
              @input="val => notaire.name = val"
              :model="notaire.name"
              data-vv-as="Nom du notaire"
              v-validate="'min:2'"
              :errors-bag="errors"
              data-vv-value-path="val">
            </v-input>
          </div>
          <div class="column is-12 columns is-multiline">
            <div class="column is-6">
              <r-label
                :label="'Téléphone'"
                :value="notaire.phone"
                :is-required="false"
                :truncate="false">
                <span
                  class="is-padding-left-xsmall"
                  v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-phone-office"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input
                    id="notairePhone"
                    :disabled="!!notaire.tiers_id"
                    name="promoteurPhone"
                    @input="val => notaire.phone = val"
                    :model="notaire.phone"
                    v-validate="'required|min:10'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                    data-vv-as="Téléphone">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <r-label
                :label="'Email'"
                :value="notaire.email"
                :is-required="false"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-paper-plane"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input
                    id="email"
                    :disabled="!!notaire.tiers_id"
                    name="email"
                    @input="val => notaire.email = val"
                    :model="notaire.email"
                    class=""
                    v-validate="'email'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Email">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <div class="control">
                  <address-input
                    v-if="!notaire.tiers_id"
                    :source="address"
                    :is-required="false"
                    @update="updateAddress">
                  </address-input>
                  <div
                    v-else
                    class="columns is-multiline">
                    <div class="column is-6">
                      <r-label
                        label="Adresse"
                        :is-required="false"
                        :value="tiersAddressResume(notaire.address)" />
                      <input
                        :value="tiersAddressResume(notaire.address)"
                        type="text"
                        class="input"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
    <div class="formActionsSticky is-bottom">
      <!-- box2 -->
      <div class=" columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <a
            @click="close()"
            class="button is-light is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button
            @click="submit"
            class="button is-success is-uppercase is-fullwidth has-text-white"
            type="submit">
            <span>Valider</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { TIERS_RESOURCE } from '@/components/tiers/tiersConstants'

export default {
  name: 'NotaireEditModal',
  components: {
    TiersSelector: () => import('@/components/tiers/TiersSelector')
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      open: {},
      notaire: {},
      address: {},
      selectedInterlocuteur: null
    }
  },
  computed: {
    notaireContact () {
      return this.source
    }
  },
  async created () {
    this.notaire = cloneDeep(this.notaireContact)
    if (this.notaire.address) {
      this.address = Object.assign({}, this.notaire.address)
    }
    if (this.notaire.tiers_id) {
      try {
        let { data } = await this.$api.getOne(TIERS_RESOURCE, this.notaire.tiers_id)
        const { interlocuteurs, ...tiers } = data
        const interlocuteur = (interlocuteurs || []).find(i => i.pk === this.notaire.interlocuteur_id)
        if (interlocuteur) {
          this.selectedInterlocuteur = { ...interlocuteur, tiers }
        }
      } catch (e) {
        this.notaire.tiers_id = null
        this.notaire.interlocuteur_id = null
      }
    }
  },
  methods: {
    /**
     * Sélection en un clic : référence la personne (interlocuteur_id) ET sa fiche (tiers_id),
     * copie les coordonnées de la fiche dans le notaire
     * @param {object} interlocuteur
     */
    selectInterlocuteur (interlocuteur) {
      this.selectedInterlocuteur = interlocuteur
      this.$set(this.notaire, 'tiers_id', interlocuteur.tiers.pk)
      this.$set(this.notaire, 'interlocuteur_id', interlocuteur.pk)
      this.notaire.name = interlocuteur.tiers.name
      this.notaire.phone = interlocuteur.tiers.phone
      this.notaire.email = interlocuteur.tiers.email
      const address = interlocuteur.tiers.address || {}
      this.updateAddress({
        line1: address.line1 || null,
        line2: address.line2 || null,
        zip_code: address.zip_code || null,
        city: address.city || null,
        country: address.country || null
      })
    },
    /**
     * Délier vide aussi les champs : évite la recréation immédiate d'un doublon
     * depuis les valeurs copiées de la fiche
     */
    unlinkTiers () {
      this.selectedInterlocuteur = null
      this.$set(this.notaire, 'tiers_id', null)
      this.$set(this.notaire, 'interlocuteur_id', null)
      this.notaire.name = null
      this.notaire.phone = null
      this.notaire.email = null
      this.updateAddress({
        line1: null,
        line2: null,
        zip_code: null,
        city: null,
        country: null
      })
    },
    updateAddress (address) {
      this.$set(this, 'address', address)
      this.notaire.address = this.address
    },
    close () {
      this.$emit('close')
    },
    /**
     * Adresse en une ligne pour l'affichage figé d'un emplacement lié
     * @param {object} address
     * @returns {string|null}
     */
    tiersAddressResume (address) {
      if (!address) return null
      const zipCity = [address.zip_code, address.city].filter(Boolean).join(' ')
      return [address.line1, zipCity, address.country].filter(Boolean).join(', ') || null
    },
    async submit () {
      if (this.notaire.tiers_id && !this.notaire.interlocuteur_id) {
        this.$toasted.global.danger('Veuillez sélectionner un interlocuteur')
        return
      }
      this.submitNotaire()
    },
    submitNotaire () {
      if (this.notaire.address) {
        if (this.notaire.address.city === '' ||
            this.notaire.address.line1 === '' ||
            this.notaire.address.country === '' ||
            this.notaire.address.zip_code === '') this.notaire.address = {}
      }
      if (this.notaire.company_name === '') this.notaire.company_name = null
      if (this.notaire.first_name === '') this.notaire.first_name = null
      if (this.notaire.last_name === '') this.notaire.last_name = null
      if (this.notaire.phone === '') this.notaire.phone = null
      if (this.notaire.email === '') this.notaire.email = null
      this.$emit('submit', this.notaire)
    }
  }
}
</script>
